/* eslint-disable no-shadow */
import Results from "@/components/Explore/Journal/Results";
import Hero from "@/components/Hero";
import { useJournal, useJournalAll } from "@/hooks/useJournal";
import useTranslation from "@/hooks/useTranslation";
import CommonLayoutWithAuth from "@/layouts/CommonWithAuth";
import { journalState } from "@/stores/journal";
import { NextPage } from "next";
import Head from "next/head";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import styles from "./styles.module.less";

const { wrapper, ac } = styles;

interface IProps {
  page: number;
  size: number;
}

const Journal: NextPage<IProps> = (props) => {
  const { changePage, loading } = useJournalAll(props);
  const { handleAc, handleSearch } = useJournal();
  const { journals, acs, displayHelper, term } = useRecoilValue(journalState);
  const { count } = displayHelper;
  const { page, size } = props;

  const { t } = useTranslation("explore");

  const acOptions = useMemo(() => {
    return acs.map((e) => ({
      label: (
        <div className={ac}>
          <div>{e.title}</div>
          <div>{e.nImpactFactor}</div>
        </div>
      ),
      value: e.title!,
    }));
  }, [acs]);

  const bannerProps = {
    title: t("journal.banner.title"),
    slogan: t("journal.banner.slogan"),
    placeholder: t("journal.banner.placeholder"),
    statement: t("journal.banner.statement"),
    handleChange: handleAc,
    acOptions,
    handleSearch,
    term,
    loadingSearch: loading,
  };

  const resultsProps = {
    count,
    page,
    size,
    term,
    journals,
    loading,
    changePage,
  };

  return (
    <CommonLayoutWithAuth>
      <Head>
        <title>
          {t("menu:explore.journal")} - {t("menu:explore.itself")} - MedicGo
        </title>
      </Head>
      <div className={wrapper}>
        <Hero {...bannerProps} />
        <Results {...resultsProps} />
      </div>
    </CommonLayoutWithAuth>
  );
};

Journal.getInitialProps = async (ctx) => {
  const page = parseInt(ctx.query.page as string, 10) || 1;
  const size = parseInt(ctx.query.size as string, 10) || 20;
  return {
    page,
    size,
    namespacesRequired: ["explore", "common", "menu"],
  };
};

export default Journal;
